import React from "react";
import { createOne } from "actions/location";
import { connect } from "react-redux";
import * as R from "ramda";
import { withRouter } from "react-router-dom";
import LocationFormFields from "components/LocationFormFields";

const mapDispatchToProps = {
  createOne
};

class AdminLocationCreate extends React.Component {
  state = {
    location: {
      id: ""
    }
  };

  handleSubmit = event => {
    event.preventDefault();
    const { createOne, history } = this.props;
    const { location } = this.state;
    createOne(location).then(data => {
      history.push("/admin/location/list");
    });
  };

  handleChange = (fields, value) => {
    this.setState(R.assocPath(fields, value));
  };

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <LocationFormFields
          location={this.state.location}
          onChange={this.handleChange}
        />
        <div className="form-group">
          <button id="submit" name="submit" className="btn btn-primary">
            Legg til lokasjon
          </button>
        </div>
      </form>
    );
  }
}

export default R.compose(withRouter, connect(null, mapDispatchToProps))(
  AdminLocationCreate
);



// WEBPACK FOOTER //
// ./src/components/AdminLocationCreate.js